import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import BaseLink from '~/components/base/BaseLink';
import Icon from '~/components/base/Icon';

import MobileNavChildMenu from '~/components/footer/MobileNavChildMenu';

import { isBrowser } from '~/utilities/helpers';

const NavButtonHeader = styled.button`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.7rem;
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    color: ${({ theme }) => theme.colors.primary.yellow};
`;
const NavLinkHeader = NavButtonHeader.withComponent(BaseLink);

const MobileNavItem = ({
    label,
    url,
    id,
    childItems,
    socialLinks = [],
    navRef,
    triggerRef,
    mainMenuIsClosed
}) => {
    const [openMenu, setOpenMenu] = useState(false);
    const headerRef = useRef();

    const isButton = childItems?.nodes?.length;
    let HeaderItem = NavLinkHeader;
    let itemProps = {
        to: url
    };

    const handleMenu = (headerRef) => {
        setOpenMenu(!openMenu);

        if (isBrowser && navRef?.current) {
            navRef.current.scrollTo({ behavior: 'smooth', top: 0 });
        }

        // Keyboard Navigation: focus header item when user closes submenu
        if (headerRef && headerRef.current) {
            headerRef.current.focus();
        }
    };

    useEffect(() => {
        setOpenMenu(mainMenuIsClosed);
    }, [mainMenuIsClosed]);

    // Keyboard Navigation: focus close trigger when menu is opened
    useEffect(() => {
        if (triggerRef?.current && openMenu) {
            triggerRef.current.focus();
        }
    }, [openMenu, triggerRef]);

    if (isButton) {
        HeaderItem = NavButtonHeader;
        itemProps = {
            'type': 'button',
            'onClick': handleMenu,
            id,
            'aria-label': `${label} Submenu`,
            'ref': headerRef
        };
    }

    return (
        <li>
            <HeaderItem {...itemProps}>
                {label}
                {isButton ? (
                    <Icon icon="arrow" color="yellow" size={13} />
                ) : null}
            </HeaderItem>
            {isButton && openMenu ? (
                <MobileNavChildMenu
                    {...{
                        label,
                        url,
                        childItems,
                        handleMenu,
                        socialLinks,
                        triggerRef,
                        headerRef
                    }}
                />
            ) : null}
        </li>
    );
};

MobileNavItem.propTypes = {
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    childItems: PropTypes.shape({}).isRequired,
    socialLinks: PropTypes.arrayOf(PropTypes.shape({})),
    navRef: PropTypes.shape({}).isRequired,
    triggerRef: PropTypes.shape({}).isRequired,
    mainMenuIsClosed: PropTypes.bool.isRequired
};

export default MobileNavItem;
